(function () {
  var pAssessBtn = document.querySelectorAll('.p-assess-age__button');
  var isPushed = false;
  var isWaiting = false;
  var firstBtn = '';
  if(pAssessBtn) {
    pAssessBtn.forEach(function (element) {

      element.addEventListener('click', function () {
        if(isWaiting) {

        } else if(isPushed) {
          isWaiting = true;
          var secondBtn = element.textContent;
          element.classList.add('on');
          $.ajax({
            type: "POST",
            url: "/assess/check",
            data: {
              "scoreUserId" : $("input[name='scoreUserId']").val(),
              "scoreTargetUserId" : $("input[name='scoreTargetUserId']").val(),
              "scorePhotoId" : $("input[name='scorePhotoId']").val(),
              "age" : firstBtn+secondBtn,
            },
            headers: {
              'X-CSRF-TOKEN': $("input[name='csrf-token']").val()
            },
            dataType : "json"
          }).done(function(data){
            if(data.result) {
              $(".p-photo__image__filter").addClass("off");
              $(".p-photo__image__filter__img").show();
              console.log(data.is_bonus);
              if(data.is_bonus) {
                $("#js-modal2").removeAttr('hidden');
              }
              setTimeout(function() {
                if(data.score_photo_path != null) {
                  $(".p-photo__image__filter__img").hide();
                  $(".p-photo__image__filter").removeClass("off");
                  $(".p-photo__image__src").attr("src", data.score_photo_path);
                  $("input[name='scoreTargetUserId']").val(data.score_target_user_id);
                  $("input[name='scorePhotoId']").val(data.score_photo_id);
                  $(".p-assess-age__button").removeClass("on");
                  isPushed = false;
                  isWaiting = false;
                } else {
                  $(".p-photo__image").hide();
                  $(".p-assess-age").hide();
                  $(".p-photo__text").addClass("show");
                }
              },3000);
            } else {
              $(".p-photo__image__filter").addClass("off");
              $(".p-photo__image__filter").append("<p class='p-photo__image__filter__text'>"+data.score_result_message+"<br><span>"+data.score_result_age+"</span>歳</p>");
              setTimeout(function() {
                // 1秒（1000ms）後に処理
                if(data.score_photo_path != null) {
                  $(".p-photo__image__filter").removeClass("off");
                  $(".p-photo__image__filter__text").remove();
                  $(".p-photo__image__src").attr("src", data.score_photo_path);
                  $("input[name='scoreTargetUserId']").val(data.score_target_user_id);
                  $("input[name='scorePhotoId']").val(data.score_photo_id);
                  $(".p-assess-age__button").removeClass("on");
                  isPushed = false;
                  isWaiting = false;
                } else {
                  $(".p-photo__image").hide();
                  $(".p-assess-age").hide();
                  $(".p-photo__text").addClass("show");
                }
              }, 3000);
            }
          }).fail(function(XMLHttpRequest, status, e){
            $(".p-assess-age__button").removeClass("on");
            alert(e);
            isPushed = false;
            isWaiting = false;
          });
        } else {
          element.classList.add('on');
          firstBtn = element.textContent;
          isPushed = true;
        }
      });
    });
  }

  $("input[name='message']").change(function (){
    var message = $(this).val();
    console.log(message);
    if(message == 'その他') {
      $(".select-other").show();
    } else {
      $(".select-other").hide();
    }
  });
  $("#reportBtn").click(function (){
    var message = $("input[name='message']:checked").val();
    var other =  $("textarea[name='other']").val();
    var isValid = true;
    var errorText = '';
    $(".p-form__error").text();
    if(message == '' || message == null ) {
      isValid = false;
      errorText = '通報理由を選択してください。'
    } else if (message == 'その他' && other == '') {
      isValid = false;
      errorText = 'その他の理由を入力してください。'
    }
    if(isValid) {
      $.ajax({
        type: "POST",
        url: "/users/report",
        data: {
          "message": message,
          "photo_id": $("input[name='scorePhotoId']").val(),
          "other": other,
        },
        headers: {
          'X-CSRF-TOKEN': $("input[name='csrf-token']").val()
        },
        dataType: "json"
      }).done(function (data) {
        var modal = document.getElementById('js-modal')
        modal.setAttribute('hidden', 'hidden')
        $(".p-photo__image__filter").addClass("off");
        $(".p-photo__image__filter").append("<p class='p-photo__image__filter__text'>通報完了しました。</p>");
        setTimeout(function () {
          // 1秒（1000ms）後に処理

          if(data.score_photo_path != null) {
            $(".p-photo__image__filter").removeClass("off");
            $(".p-photo__image__filter__text").remove();
            $(".p-photo__image__src").attr("src", data.score_photo_path);
            $("input[name='scoreTargetUserId']").val(data.score_target_user_id);
            $("input[name='scorePhotoId']").val(data.score_photo_id);
            $(".p-assess-age__button").removeClass("on");
            isPushed = false;
            isWaiting = false;

          } else {
            $(".p-photo__image").hide();
            $(".p-assess-age").hide();
            $(".p-photo__text").addClass("show");
          }

        }, 3000);
      }).fail(function (XMLHttpRequest, status, e) {
        console.log(e);
        alert(e);
      });
    } else {
      $(".p-form__error").text(errorText);
    }
  })
})();
